import React from 'react';
import { motion } from 'framer-motion';
import { ServiceCard } from './ServiceCard';
import { WarehouseIcon, ScaleIcon, TruckIcon } from 'lucide-react';
export function Services() {
  const services = [{
    icon: WarehouseIcon,
    title: 'Renta de Bodegas',
    description: 'Bodegas de 1,250 y 1,500 m², listas para operar, con oficina, servicios sanitarios, área de maniobra y seguridad integral. Ideales para empresas que buscan un punto logístico estratégico hacia Ciudad de Guatemala y la región.',
    internalLink: '#bodegas',
    buttonText: 'Ver Bodegas Disponibles'
  }, {
    icon: ScaleIcon,
    title: 'Báscula para Camiones',
    description: 'Servicio de báscula para camiones con contenedores, dentro del complejo, facilitando el control de peso y la operación diaria de flotas de carga nacional y regional.',
    whatsappLink: 'https://wa.me/50245607548?text=Hola%2C%20quiero%20información%20sobre%20el%20servicio%20de%20Báscula%20en%20Bodenor.',
    buttonText: 'Solicitar información de Báscula'
  }, {
    icon: TruckIcon,
    title: 'Patio de Camiones',
    description: 'Parque de estacionamiento para más de 200 camiones, con muro perimetral, seguridad y cámaras de vigilancia en todo el complejo. Un punto seguro para operaciones de transporte y almacenamiento.',
    whatsappLink: 'https://wa.me/50245607548?text=Hola%2C%20estoy%20interesado%20en%20el%20Patio%20de%20Camiones%20de%20Bodenor.',
    buttonText: 'Patio de Camiones'
  }];
  return <section id="services" className="bg-black py-20 px-4 relative overflow-hidden scroll-mt-20" data-id="element-176">
      {/* Background elements */}
      <div className="absolute inset-0 opacity-5" data-id="element-177">
        <div className="absolute inset-0" style={{
        backgroundImage: `
            linear-gradient(rgba(252, 211, 77, 0.3) 1px, transparent 1px),
            linear-gradient(90deg, rgba(252, 211, 77, 0.3) 1px, transparent 1px)
          `,
        backgroundSize: '80px 80px'
      }} data-id="element-178" />
      </div>

      <div className="max-w-7xl mx-auto relative z-10" data-id="element-179">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="text-center mb-16" data-id="element-180">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4" data-id="element-181">
            Nuestros <span className="text-yellow-400" data-id="element-182">Servicios</span>
          </h2>
          <motion.div initial={{
          width: 0
        }} whileInView={{
          width: 96
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8,
          delay: 0.3
        }} className="h-1 bg-gradient-to-r from-transparent via-yellow-400 to-transparent mx-auto" data-id="element-183" />
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-184">
          {services.map((service, index) => <ServiceCard key={index} {...service} index={index} data-id="element-185" />)}
        </div>
      </div>
    </section>;
}